module.exports = __webpack_public_path__ + "static/media/sold_out.38068493.png";